module.exports = __webpack_public_path__ + "static/media/unboxing_summer_1.fb6b8f7b.jpg";